import { ActiveToggle } from './libs/active-toggle';

document.addEventListener('DOMContentLoaded', function () {
  const activeToogle = new ActiveToggle();
});
